import { render } from "./ProjectSettings.vue?vue&type=template&id=4df4e7f8&scoped=true"
import script from "./ProjectSettings.vue?vue&type=script&lang=js"
export * from "./ProjectSettings.vue?vue&type=script&lang=js"

import "./ProjectSettings.vue?vue&type=style&index=0&id=4df4e7f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df4e7f8"]])

export default __exports__